import { Observable, BehaviorSubject} from 'rxjs';

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';

import { GlobalNamespace as _GlobalNS } from './../../../environments/environment';
import { RelationshipTypeConfiguration, ConfigurationType } from './configuration';
import { RelationshipType as PartnershipType } from './../../partnership/models/partner';
import { FormBuilder, FormArray } from '@angular/forms';
import { GlobalService } from '../../core';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
};

@Injectable({
  providedIn: 'root'
})

export class ConfigurationService {

  constructor(
    private readonly _http: HttpClient,
    private readonly fb: FormBuilder,
    private _global: GlobalService
  ) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  private relationshipType = new BehaviorSubject<any>([]);
  private configurationType = new BehaviorSubject<any>([]);

  getRelationshipType = this.relationshipType.asObservable();
  getConfigurationType = this.configurationType.asObservable();

  setRelationshipType(data: RelationshipTypeConfiguration) {
    this.relationshipType.next(data);
  }

  setConfigurationType(type: PartnershipType, config: ConfigurationType) {
    this.configurationType.next({ type: type, config: config });
  }

  update(data: RelationshipTypeConfiguration) {
    const api = (<any>_GlobalNS).api.setting.partner.type;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    return this._http.post(`${api}&eqrf=${eqrf}`, data, this.httpOptions);
  }

  findRelationshipTypes(): Observable<PartnershipType> {
    const api = (<any>_GlobalNS).api.setting.partner.type;

    return this._http.get<any>(api);
  }

  // STEP TWO
  findByRelationshipTypeID(id): Observable<ConfigurationType[]> {
    const api = (<any>_GlobalNS).api.setting.partner.typeById;
    const params = new HttpParams().set('RelationshipTypeId', id).set('ResultType', 'ALL');

    return this._http.get<ConfigurationType[]>(api, { params });
  }

  findRelationshipTypeConfigurations(){
    let configs = [];
    this.findRelationshipTypes().subscribe(data => {
      let rtypes = (<any>data).data;
    });
  }

  findRelationshipTypeSettingsByAccessTypeId(id){
    const params = new HttpParams().set('AccessTypeId', id);

    const api = '/assets/data/mock-relationshiptypesettings.json';
    return this._http.get<any[]>(api, { params });
  }

  save(configuration) {
    const api = (<any>_GlobalNS).api.setting.partner.save;
    const eqrf = this._global.find((<any>_GlobalNS).paths.eqrf);
    return this._http.post(`${api}&eqrf=${eqrf}`, configuration, this.httpOptions);
  }

}
